module.exports = {"data":{"markdownRemark":{"frontmatter":{"indicators":[{"title":"Renter Households","dataKey":"renter-households"},{"title":"Renters Living in Poverty","dataKey":"poverty-rate"},{"title":"Fair Market Rent","dataKey":"fair-market-rent"},{"title":"Affordable Rent","dataKey":"affordable-rent"},{"title":"Work Hours Needed","dataKey":"work-hours-needed"},{"title":"Affordable Housing Supply","dataKey":"affordable-housing-supply"},{"title":"Housing Cost Burden","dataKey":"housing-cost-burden"}]}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 300
// module chunks = 60335399758886 114276838955818